<script>
import baseMixin from '@/mixins/baseMixin'
import { mapActions } from 'vuex'
import { getType } from 'mime'
import { isNullOrEmptyArray } from '@/helpers/array-helpers'

export default {
  name: 'FormSubmissionDownloadStampedPdfBtn',
  mixins: [baseMixin],
  props: {
    passkey: {
      type: String,
      default: '',
    },
    hasPdfConfiguration: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      isLoading: false,
      urls: [],
    }
  },
  computed: {
    hasPasskey() {
      return !!this.passkey
    },
    isDisabled() {
      return !this.hasPasskey || !this.hasPdfConfiguration
    },
  },
  beforeDestroy() {
    this.revokePdfObjUrls()
  },
  methods: {
    ...mapActions({
      downloadStampedPdf: 'forms/downloadStampedPdf',
    }),
    revokePdfObjUrls() {
      if (isNullOrEmptyArray(this.urls)) return

      for (const url of this.urls) {
        if (!url) continue
        window.URL.revokeObjectURL(url)
      }
    },
    async downloadPdf() {
      if (!this.hasPasskey) return

      this.isLoading = true

      const result = await this.downloadStampedPdf(this.passkey)

      if (result.isSuccess) {
        // Handles scenario if content-disposition header is missing
        const pdfFileData = new Blob([result.data.blob], {
          type: getType(`${this.passkey}.pdf`),
        })

        // Create a URL for the Blob object
        const url = URL.createObjectURL(pdfFileData)

        // Cache URL so that it may be revoked later
        this.urls.push(url)

        // Open the Blob object in a new tab
        window.open(url, '_blank')
      }

      this.isLoading = false
    },
  },
}
</script>

<template>
  <v-tooltip :disabled="isDisabled" top>
    <template v-slot:activator="{ on, attrs }">
      <BaseButton
        v-if="!isDisabled"
        icon
        :loading="isLoading"
        v-bind="attrs"
        data-testid="download-stamped-pdf-base-button"
        @click="downloadPdf"
        v-on="on"
      >
        <v-icon>mdi-stamper</v-icon>
      </BaseButton>
    </template>
    <span class="ws-pre-wrap">{{
      $t('forms.stampedPdf.downloadTooltip')
    }}</span>
  </v-tooltip>
</template>
